import { render, staticRenderFns } from "./courseInner.vue?vue&type=template&id=a118b228&scoped=true&"
import script from "./courseInner.vue?vue&type=script&lang=js&"
export * from "./courseInner.vue?vue&type=script&lang=js&"
import style0 from "./courseInner.vue?vue&type=style&index=0&id=a118b228&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a118b228",
  null
  
)

export default component.exports